import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { Api, cancelRequest } from '../../api/Assinafy';
import { signerColors } from '../../utils/Signers';
import { usePrepareContext } from '../../routes/PrepareRoute';
import { PrepareNavbar } from '../../layout/Prepare';
import { Dashboard, Scroll, Section } from '../../layout';
import { Form, Table, Avatar, Textarea, Icon, Input, Alert } from '../../components';

const TemplateReviewDocument = ({ virtual }) => {
	const [
		documentContext,
		setDocumentContext,
		signersContext,
		,
		fieldsContext
	] = usePrepareContext();
	const [loading, setLoading] = useState(false);
	const [formError, setFormError] = useState([]);
	const [formData, setFormData] = useState({});
	const [showExpiration, setShowExpiration] = useState(false);
	const { id: documentId } = useParams();
	const navigate = useNavigate();
	const cancelToken = cancelRequest();

	const handleSubmit = (event) => {
		event.preventDefault();

		setLoading(true);
	  
		if (!formData.name || formData.name.length < 5) {
		  setFormError(['O nome do template é obrigatório e precisa ter no mínimo 5 caracteres']);
		  setLoading(false);
		  return;
		}
	  
		if (!virtual) {
		  return Api('template/update')(documentId, {
			...formData
		  })
			.then(({ status }) => {
			  if (status === 200) {
				navigate(`/dashboard/templates/${documentId}/sent`, {
				  state: {
					name: formData.name,
					id: documentId
				  }
				});
			  }
			})
			.catch(({ response }) => {
			  if (response) {
				setFormError([response.data.message]);
			  }
			  setLoading(false);
			});
		}
	};
	  

	const fieldValueChange = (name, value) => {
		setFormData((prevFormData) => ({
		  ...prevFormData,
		  [name]: value
		}));
	};
	  

	const handleOpenClick = () => {
		setShowExpiration(true);
	};

	const handleCloseClick = () => {
		setShowExpiration(false);
	};

	useEffect(() => {
		Api('template/view')(documentId, {
			...cancelToken.config
		}).then(({ status, data }) => {
			if (status === 200) {
				window.pageCanvas = [];
				setDocumentContext(data.data);
			}
		});

		return () => {
			cancelToken.cancel();
		};
	}, []);

	return (
		<Form
			id="form-document-review"
			className="form-prepare"
			onSubmit={handleSubmit}
		>
			<PrepareNavbar
				document={documentContext}
				step="review"
				submitLoading={loading}
				text="Revisão e conclusão"
				url="templates"
			/>
			<Scroll>
				<Dashboard.Content>
					<Row>
						<Col md={{ span: 8, offset: 2 }}>
							<Dashboard.Header title="Revisão e conclusão" />

							<Alert
								show={formError.length}
								variant="warning"
								onClose={() => setFormError([])}
							>
								{formError.map((error) => error)}
							</Alert>

							<Section>
								<Section.Header
									title="Nome do template"
									opening="Você vai poder personalizar o nome a cada envio"
								/>
								<Form.Group>
								<Input.Variable
									size="lg"
									name="name" // Verifique se o name está correto
									label="Nome do template"
									minLength="5"
									value={formData.name || ''} // Certifique-se de que o valor está sendo passado corretamente
									variables={signersContext.map((signer) => signer.name)}
									onChange={(event) =>
										fieldValueChange(
											event.target.name,
											event.target.value
										)
									} // Aqui o formData precisa ser atualizado
									/>

								</Form.Group>
							</Section>


							<SectionSigners signers={signersContext} />

							<Section>
								<Section.Header
									title="Mensagem"
									opening="Esta mensagem será enviada a todos que vão receber o documento, e pode ser personalizada a cada utilização deste template"
								/>
								<Form.Group>
									<Textarea
										name="message"
										onChange={(event) =>
											fieldValueChange(
												event.target.name,
												event.target.value
											)
										}
										label="Mensagem"
									/>
								</Form.Group>
							</Section>
						</Col>
					</Row>
				</Dashboard.Content>
			</Scroll>
		</Form>
	);
};

const SectionSigners = ({ signers }) => {
	return (
		<Section>
			<Section.Header
				title="Signatários"
				opening="Verifique se você associou todos os papéis de quem vai assinar ou receber uma cópia do documento"
			/>
			<Table
				rows={signers}
				renderRow={(signer, i) => (
					<tr key={i}>
						<td>
							<div className="signer-header">
								<Avatar
									placeholder={
										<Icon
											id="icon-initial"
											className="mt-1"
											size="20"
										/>
									}
									bgColor={signerColors[i].color}
								/>
								{signer.name}
								{signer.assignment_type && (
									<span className="ms-1 text-muted">
										{signer.assignment_type === 'Signer'
											? 'Assina o documento'
											: 'Recebe uma cópia'}
									</span>
								)}
							</div>
						</td>
						<td>{signer.email}</td>
					</tr>
				)}
			/>
		</Section>
	);
};

export default TemplateReviewDocument;
